<app-header></app-header>
<div style="background:#26abe3" class="header-search-bar">
  <div class="container">
    <div class="header-search-bar-main">
      <form #searchDoctor="ngForm" (ngSubmit)="searchDoctorForm(searchDoctor)">
        <div class="row">
          <div class="col-md-6 col-lg-3">
              <div class="ng-autocomplete1 form-group-img">
                  <ng-autocomplete 
                    [data]="cities"
                    placeHolder ="Select City Name"
                    [initialValue] ="object.city"
                    [searchKeyword]="object.city"
                    (selected)='selectEvent($event,searchDoctor)'
                    (inputChanged)='onChangeSearch($event)'
                    (inputFocused)='onFocused($event)'
                    [itemTemplate]="itemTemplate"
                    [notFoundTemplate]="notFoundTemplate"
                    name="city" [(ngModel)]="object.city"
                    >                                 
                  </ng-autocomplete>
                   
                  <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item"></a>
                  </ng-template>
                   
                  <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="notFound"></div>
                  </ng-template>
                  <span class="c-omni-searchbox__button-container">
                    <span class="c-omni-searchbox__button c-omni-searchbox__button" data-qa-id="current_location">
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                      <span (click)="detectLocation(searchDoctor)" *ngIf="searchDoctor.value.city!=currentCity" class="c-omni-searchbox__button__text">
                        Detect </span>
                      </span>
                    </span>
                  <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                  </div>
                  <!-- <input type="hidden" > -->
            <!-- <div class="form-group-img">
              <select (change)="searchDoctorForm(searchDoctor)" [(ngModel)]="object.city" name="city"
                      class="form-control">
                <option value=''>Choose City...</option>
                <option [hidden]="city==''" *ngFor="let city of cities" [value]="city">{{ city }}</option>
              </select>
              <i class="fa fa-map-marker" aria-hidden="true"></i>
            </div> -->
          </div>
          <div class="col-md-6  col-lg-4">
            <div class="form-group-img">
              <input [(ngModel)]="object.name" name="name" type="text" class="form-control"
                     placeholder="Search doctor by name..">
              <i class="fa fa-search" aria-hidden="true"></i>
            </div>
          </div>
          <div class="col-md-12 col-lg-5">
            <div class="form-group-btn">
                <div class="ng-autocomplete1 form-group-img">
                    <ng-autocomplete 
                      [data]="specialities"
                      placeHolder ="Search doctor by Speciality (Optional)"
                      [searchKeyword]="object.treatment"
                      (selected)='selectEvent1($event,searchDoctor)'
                      (inputChanged)='onChangeSearch($event)'
                      (inputFocused)='onFocused($event)'
                      [itemTemplate]="itemTemplate1"
                      
                      name="treatment" [(ngModel)]="object.treatment"
                      >                                 
                    </ng-autocomplete>
                     
                    <ng-template #itemTemplate1 let-item>
                    <a [innerHTML]="item"></a>
                    </ng-template>
                     
                    <!-- <ng-template #notFoundTemplate let-notFound>
                    <div [innerHTML]="notFound"></div>
                    </ng-template> -->
                    <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                    </div>
              <!-- <input name="treatment" [(ngModel)]="object.treatment" type="text" class="form-control"
                     placeholder="Treatment,Speciality (Optional)"> -->
              <input type="submit" class="btn-style" value="Search">
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- </header> -->

<div *ngIf="showfilters" class="header-btm-search-bg">
  <section class="header-btm-search">
    <div class="container">
      <form>
        <div class="header-btm-search">
          <ul>
            <li>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                       (click)="locationRating('location',$event);rating='';" [(ngModel)]="location"
                       id="customCheck1234" name="example_1">
                <label class="custom-control-label" for="customCheck1234"> By Location </label>
              </div>
            </li>
            <li>
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input"
                       (click)="locationRating('rating',$event);location=''" [(ngModel)]="rating" id="customCheck3453"
                       name="example_2">
                <label class="custom-control-label" for="customCheck3453"> By Rating </label>
              </div>
            </li>
            <li>
              <div class="sort-resutls" (click)="togglefilter = !togglefilter" id="sort-resutls-btn"> Sort Results by <i
                class="fa fa-angle-down" aria-hidden="true"></i></div>
            </li>
            <li><a [routerLink]="null" (click)="applyFilter()" class="btn-style btn-style-small"> Apply Filter </a></li>
            <li *ngIf="filterApplied"><a [routerLink]="null" (click)="clearFilter()"
                                         class="btn-style btn-style-small btn-style-grey"> Clear Filter </a></li>
          </ul>
        </div>
      </form>
    </div>
  </section>
  <div [hidden]="!togglefilter" class="header-btm-sort-results">
    <div class="container">
      <ul class="clearfix">
        <li>
          <div class="header-btm-sort-box">
            <h5> Availability </h5>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     (click)="onCheckAvailability(availability[0].value,$event);availability2='';availability3='';availability4=''"
                     [(ngModel)]="availability1" value="Today" [id]="'cutm-check-1'" name="example1">
              <label class="custom-control-label" [for]="'cutm-check-1'"> Today </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     (click)="onCheckAvailability(availability[1].value,$event);availability1='';availability3='';availability4=''"
                     [(ngModel)]="availability2" value="This_week" [id]="'cutm-check-2'" name="example2">
              <label class="custom-control-label" [for]="'cutm-check-2'"> This Week </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Next_Week"
                     (click)="onCheckAvailability(availability[2].value,$event);;availability1='';availability2='';availability4=''"
                     [id]="'cutm-check-3'" [(ngModel)]="availability3" name="example3">
              <label class="custom-control-label" [for]="'cutm-check-3'"> Next Week </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Next_Month"
                     (click)="onCheckAvailability(availability[3].value,$event);;availability1='';availability2='';availability3=''"
                     [id]="'cutm-check-4'" [(ngModel)]="availability4" name="example4">
              <label class="custom-control-label" [for]="'cutm-check-4'"> Next Month </label>
            </div>

          </div>
        </li>
        <li>
          <div class="header-btm-sort-box">
            <h5> Consultation Days </h5>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     (click)="onCheckConsultation(consultation[0],$event);consultation2='';consultation3='';consultation4='';consultation5='';consultation6='';consultation7=''"
                     [(ngModel)]="consultation1" value="Monday" [id]="'cons-check-1'" name="example5">
              <label class="custom-control-label" [for]="'cons-check-1'"> Monday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input"
                     (click)="onCheckConsultation(consultation[1],$event);consultation1='';consultation3='';consultation4='';consultation5='';consultation6='';consultation7=''"
                     [(ngModel)]="consultation2" value="Tuesday" [id]="'cons-check-2'" name="example6">
              <label class="custom-control-label" [for]="'cons-check-2'"> Tuesday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Wednesday"
                     (click)="onCheckConsultation(consultation[2],$event);consultation1='';consultation2='';consultation4='';consultation5='';consultation6='';consultation7=''"
                     [id]="'cons-check-3'" [(ngModel)]="consultation3" name="example7">
              <label class="custom-control-label" [for]="'cons-check-3'"> Wednesday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Thursday"
                     (click)="onCheckConsultation(consultation[3],$event);consultation1='';consultation3='';consultation2='';consultation5='';consultation6='';consultation7=''"
                     [id]="'cons-check-4'" [(ngModel)]="consultation4" name="example8">
              <label class="custom-control-label" [for]="'cons-check-4'"> Thursday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Friday"
                     (click)="onCheckConsultation(consultation[4],$event);consultation1='';consultation3='';consultation4='';consultation2='';consultation6='';consultation7=''"
                     [id]="'cons-check-5'" [(ngModel)]="consultation5" name="example9">
              <label class="custom-control-label" [for]="'cons-check-5'"> Friday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Saturday"
                     (click)="onCheckConsultation(consultation[5],$event);consultation1='';consultation3='';consultation4='';consultation2='';consultation5='';consultation7=''"
                     [id]="'cons-check-6'" [(ngModel)]="consultation6" name="example10">
              <label class="custom-control-label" [for]="'cons-check-6'"> Saturday </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Sunday"
                     (click)="onCheckConsultation(consultation[6],$event);consultation1='';consultation3='';consultation4='';consultation2='';consultation5='';consultation6=''"
                     [id]="'cons-check-7'" [(ngModel)]="consultation7" name="example11">
              <label class="custom-control-label" [for]="'cons-check-7'"> Sunday </label>
            </div>

          </div>
        </li>
        <li>
          <div class="header-btm-sort-box">
            <h5> Timings </h5>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Morning"
                     (click)="onCheckTiming(timing[0],$event);timing2='';timing3=''" [id]="'tim-check-1'"
                     [(ngModel)]="timing1" name="example12">
              <label class="custom-control-label" [for]="'tim-check-1'"> Morning </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="AfterNoon"
                     (click)="onCheckTiming(timing[1],$event);timing1='';timing3=''" [id]="'tim-check-2'"
                     [(ngModel)]="timing2" name="example13">
              <label class="custom-control-label" [for]="'tim-check-2'"> AfterNoon </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Evening"
                     (click)="onCheckTiming(timing[2],$event);timing1='';timing2=''" [id]="'tim-check-3'"
                     [(ngModel)]="timing3" name="example14">
              <label class="custom-control-label" [for]="'tim-check-3'"> Evening </label>
            </div>

          </div>
        </li>
        <li>
          <div class="header-btm-sort-box">
            <h5> Language Spoken </h5>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="English"
                     (click)="onCheckLang(languages[0],$event);language2=''" [id]="'lang-check-1'"
                     [(ngModel)]="language1" name="example15">
              <label class="custom-control-label" [for]="'lang-check-1'"> English </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Hindi"
                     (click)="onCheckLang(languages[1],$event);language1=''" [id]="'lang-check-2'"
                     [(ngModel)]="language2" name="example16">
              <label class="custom-control-label" [for]="'lang-check-2'"> Hindi </label>
            </div>

          </div>
        </li>
        <li>
          <div class="header-btm-sort-box">
            <h5> Gender </h5>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Male"
                     (click)="onCheckGender(gender[0],$event);gender2=''" [id]="'gen-check-1'" [(ngModel)]="gender1"
                     name="example17">
              <label class="custom-control-label" [for]="'gen-check-1'"> Male </label>
            </div>
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" value="Female"
                     (click)="onCheckGender(gender[1],$event);gender1=''" [id]="'gen-check-2'" [(ngModel)]="gender2"
                     name="example18">
              <label class="custom-control-label" [for]="'gen-check-2'"> Female </label>
            </div>

          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<section class="doctors padd-row">
  <div class="container">
    <div class="doctors-main">
      <div class="row">
        <div *ngFor="let doctor of doctorList" style="cursor:pointer" (click)="openDoctorDetail(doctor.uniqueKey)"
             class="col-md-6">
          <div class="doctor-box">
            <div class="doctor-box-top">
              <div class="doctor-box-img">
                <img [src]="doctor.profilePicture" alt="image">
              </div>
              <div *ngIf="doctor.discount" class="offer-sticker"> {{ doctor.discount }}% off</div>
              <div class="doctor-box-top-cnt">
                <div class="d-md-flex">
                  <h5><a
                    [routerLink]="['/doctors/detail/'+doctor.uniqueKey]"> {{ doctor.name }} </a>
                    <span style="cursor:pointer">  
                      {{ doctor?.speciality?.join(' | ').slice(0,25) }}
                      <!-- {{ doctor?.speciality?.join(' | ') }} -->
                      <!-- <read-more [text]="doctor?.education?.slice(0,3).join(' | ')" [maxLength]="50" [showToggleButton]="true"></read-more> -->
                      </span>
                  </h5>
                  <div class="doctor-box-rating">
                    <i class="fa fa-star" aria-hidden="true"></i> <span> {{ parseInt(doctor.averageRatings) }}/5 </span>
                    <p> {{ doctor.review.length }} Reviews </p>
                  </div>
                </div>
                <div class="doc-box-adrs">
                  <p> {{ doctor.experience }} yrs Experience </p>
                  <p> {{ doctor.address }} </p>
                </div>
              </div>
            </div>
            <div class="doctor-box-btm">
              <div class="d-lg-flex" *ngIf="isArray( doctor?.services)">
                <ul>
                  <li *ngFor="let service of doctor?.services?.slice(0,3)"> {{ service }} </li>
                  <!-- <li> Crowns Fixing </li>
                  <li> Endosurgery </li>
                  <li> Fixed Partial Denture (FPD) </li>
                  <li> Conservative Density </li>
                  <li> Crowns Fixing </li> -->
                </ul>
                <div class="doc-box-btm-btns">
                  <a *ngIf="doctor?.isAvailable" [routerLink]="['/doctors/detail/'+doctor.uniqueKey]"
                     class="btn-style btn-style-border"> Consult
                    Online </a>
                  <a [routerLink]="['/doctors/detail/'+doctor.uniqueKey]" class="btn-style"> Book
                    Appointment </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="doctors-pagination">
          <ul>
            <li class="current-pagi"> 1 </li>
            <li> <a href="javascript://" > 2 </a>  </li>
            <li> <a href="javascript://"> 3 </a>  </li>
            <li> <a href="javascript://"> 4 </a>  </li>
            <li> <a href="javascript://" class="next"> Next </a>  </li>
          </ul>
      </div> -->
    </div>
  </div>
</section>
<!--- End of doctors -->
<ngx-spinner></ngx-spinner>
